(function () {

  function initM2Calculator() {
    const calcEl      = document.getElementById('m2-calculator');
    const heightInput = document.getElementById('m2-height');
    const resultEl    = document.getElementById('m2-result');
    const enDisplay   = calcEl?.querySelector('.m2-en-display');

    if (!calcEl) return;

    const qtyWrapper = document.querySelector('quantity-input');
    const qtyInput   = qtyWrapper?.querySelector('input');

    // ── Qty kutusunu gizle / göster ──────────────────────────────
    function setQtyVisibility(isM2) {
      if (!qtyWrapper) return;
      qtyWrapper.style.display = isM2 ? 'none' : '';

      // Dawn'da quantity-input'un parent wrapper'ı da olabilir
      const parent = qtyWrapper.closest(
        '.product-form__quantity, .quantity-wrapper, [class*="quantity"]'
      );
      if (parent) parent.style.display = isM2 ? 'none' : '';
    }

    // Sayfa açılışında başlangıç durumu
    const initialActive = calcEl.dataset.active === 'true';
    calcEl.style.display = initialActive ? 'block' : 'none';
    setQtyVisibility(initialActive);

    // ── Alan & fiyat hesabı ──────────────────────────────────────
    function calculate() {
      const en    = parseFloat(calcEl.dataset.en    || 0); // cm
      const h     = parseFloat(heightInput?.value   || 0); // cm
      const price = parseFloat(calcEl.dataset.price || 0); // ₺/m² (gerçek)

      if (!en || !h || h <= 0) {
        if (resultEl) resultEl.innerHTML = '';
        return;
      }

      const m2      = (en / 100) * (h / 100);        // gerçek m²
      const rounded = Math.round(m2 * 100) / 100;    // 2 ondalık
      const total   = rounded * price;               // ₺ toplam

      // Sonucu ekranda göster
      if (resultEl) {
        resultEl.innerHTML = `
          <span class="m2-calc-area">
            Alan: <strong>${rounded.toFixed(2)} m²</strong>
          </span>
          ${price > 0
            ? `<span class="m2-calc-total">
                Tahmini Tutar: <strong>${total.toFixed(2)} ₺</strong>
               </span>`
            : ''}
        `;
      }

      // Shopify qty: 1 birim = 0.01 m² → qty = m² × 100
      // Bu qty müşteriden gizlenir (setQtyVisibility ile)
      const qty = Math.ceil(m2 * 100);
      if (qtyInput) {
        qtyInput.value = qty;
        qtyInput.dispatchEvent(new Event('input',  { bubbles: true }));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Sepette görünecek boyut bilgisi (line item property)
      _setHiddenProp('m2-dimension-prop', 'Boyut',  `${en} cm × ${h} cm`);
      _setHiddenProp('m2-amount-prop',    'Miktar', `${rounded.toFixed(2)} m²`);
    }

    // Gizli input oluştur veya güncelle
    function _setHiddenProp(id, name, value) {
      let el = document.getElementById(id);
      if (!el) {
        el       = document.createElement('input');
        el.type  = 'hidden';
        el.name  = `properties[${name}]`;
        el.id    = id;
        document.querySelector('form[action="/cart/add"]')?.appendChild(el);
      }
      el.value = value;
    }

    // ── Varyant değişince hesaplayıcıyı güncelle ─────────────────
    function updateCalcFromVariantId(variantId) {
      // __variantMeta Liquid tarafından sayfaya gömülür
      const meta = window.__variantMeta?.[String(variantId)];
      if (!meta) return;

      const en   = parseFloat(meta.en) || 0;
      const isM2 = meta.is_m2 === true || meta.is_m2 === 'true';

      calcEl.dataset.en    = en;
      calcEl.style.display = isM2 ? 'block' : 'none';
      setQtyVisibility(isM2);

      if (enDisplay) enDisplay.textContent = en ? `${en} cm` : '';

      // Shopify'dan güncel fiyatı çek
      const handle = window.location.pathname.split('/products/')[1]?.split('?')[0];
      if (!handle) return;

      fetch(`/products/${handle}.js`)
        .then(r => r.json())
        .then(product => {
          const variant = product.variants.find(v => v.id == variantId);
          if (!variant) return;

          // Python: Shopify fiyatı = m²_fiyatı / 100
          // Gerçek m² fiyatı = (variant.price kuruş / 100 TL) × 100 = variant.price
          // Yani: variant.price (kuruş) === gerçek m² fiyatı (TL)
          const storedTL  = variant.price / 100;           // kuruş → TL
          const m2PriceTL = isM2 ? storedTL * 100 : storedTL;

          calcEl.dataset.price = m2PriceTL.toFixed(2);

          // Girişleri temizle
          if (heightInput) heightInput.value  = '';
          if (resultEl)    resultEl.innerHTML = '';
        })
        .catch(err => console.warn('[m2-calc] Fiyat çekilemedi:', err));
    }

    // ── Event listeners ──────────────────────────────────────────

    // Boy girilince hesapla
    if (heightInput) {
      heightInput.addEventListener('input', calculate);
    }

    // Varyant değişince güncelle
    document.addEventListener('change', function (e) {
      const variantSelector = e.target.closest('variant-selects, variant-radios');
      if (!variantSelector) return;

      const form = variantSelector.closest('form');
      if (!form)  return;

      const selectedVariantId = form.querySelector('[name="id"]')?.value;
      if (!selectedVariantId) return;

      updateCalcFromVariantId(selectedVariantId);
    });

    // ── Sayfa açılışında aktif varyantı yükle ────────────────────
    const form      = document.querySelector('form[action="/cart/add"]');
    const initialId = form?.querySelector('[name="id"]')?.value;
    if (initialId) updateCalcFromVariantId(initialId);
  }

  // DOM hazır olunca başlat
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initM2Calculator);
  } else {
    initM2Calculator();
  }

})();